const pwa={
    BANNER_DES:"برنامه آموزش آفیس را روی گوشی نصب کنید",
    INSTALL_NOW:"همین حالا نصب کن",
    DENY:"بعداً",
    INSTALL_SUCCESS:"برنامه با موفقیت روی گوشی شما نصب شد",
    INSTALL_FAIL:"نصب برنامه با خطا مواجه شد"
}

export default pwa
